export enum TelephonyWidgetContainer {
  OUTBOUND = 'Outbound',
  RECENT = 'Recent',
  CALL = 'Call',
  QUICK_CONNECT = 'Quick Connect',
  NUMPAD = 'Numpad'
}
